/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  BodyImportsCsvUpload,
  CreateLinkTokenResponse,
  HTTPValidationError,
  ImportResponse,
  ImportsCreateAccessTokenAndSaveInvestmentsParams,
  ImportsDeleteImportSource200,
  SupportedBrokersResponse,
  SyncImportSourceRequest,
  UserImportSourceInput,
  UserImportSourceOutput,
  WebhookRequest
} from './client.schemas'




/**
 * @summary Sync Import Source
 */
export const importsSyncImportSource = (
    syncImportSourceRequest: SyncImportSourceRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportResponse>> => {
    
    return axios.default.post(
      `/imports/sync_source`,
      syncImportSourceRequest,options
    );
  }



export const getImportsSyncImportSourceMutationOptions = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsSyncImportSource>>, TError,{data: SyncImportSourceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importsSyncImportSource>>, TError,{data: SyncImportSourceRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsSyncImportSource>>, {data: SyncImportSourceRequest}> = (props) => {
          const {data} = props ?? {};

          return  importsSyncImportSource(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsSyncImportSourceMutationResult = NonNullable<Awaited<ReturnType<typeof importsSyncImportSource>>>
    export type ImportsSyncImportSourceMutationBody = SyncImportSourceRequest
    export type ImportsSyncImportSourceMutationError = AxiosError<void | HTTPValidationError>

    /**
 * @summary Sync Import Source
 */
export const useImportsSyncImportSource = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsSyncImportSource>>, TError,{data: SyncImportSourceRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof importsSyncImportSource>>,
        TError,
        {data: SyncImportSourceRequest},
        TContext
      > => {

      const mutationOptions = getImportsSyncImportSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Add And Sync Import Source
 */
export const importsAddAndSyncImportSource = (
    userImportSourceInput: UserImportSourceInput, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportResponse>> => {
    
    return axios.default.post(
      `/imports/add_and_sync_source`,
      userImportSourceInput,options
    );
  }



export const getImportsAddAndSyncImportSourceMutationOptions = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsAddAndSyncImportSource>>, TError,{data: UserImportSourceInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importsAddAndSyncImportSource>>, TError,{data: UserImportSourceInput}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsAddAndSyncImportSource>>, {data: UserImportSourceInput}> = (props) => {
          const {data} = props ?? {};

          return  importsAddAndSyncImportSource(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsAddAndSyncImportSourceMutationResult = NonNullable<Awaited<ReturnType<typeof importsAddAndSyncImportSource>>>
    export type ImportsAddAndSyncImportSourceMutationBody = UserImportSourceInput
    export type ImportsAddAndSyncImportSourceMutationError = AxiosError<void | HTTPValidationError>

    /**
 * @summary Add And Sync Import Source
 */
export const useImportsAddAndSyncImportSource = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsAddAndSyncImportSource>>, TError,{data: UserImportSourceInput}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof importsAddAndSyncImportSource>>,
        TError,
        {data: UserImportSourceInput},
        TContext
      > => {

      const mutationOptions = getImportsAddAndSyncImportSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Supported Brokers Info
 */
export const importsGetSupportedBrokersInfo = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SupportedBrokersResponse>> => {
    
    return axios.default.get(
      `/imports/supported_brokers`,options
    );
  }


export const getImportsGetSupportedBrokersInfoQueryKey = () => {
    return [`/imports/supported_brokers`] as const;
    }

    
export const getImportsGetSupportedBrokersInfoQueryOptions = <TData = Awaited<ReturnType<typeof importsGetSupportedBrokersInfo>>, TError = AxiosError<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsGetSupportedBrokersInfo>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsGetSupportedBrokersInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsGetSupportedBrokersInfo>>> = ({ signal }) => importsGetSupportedBrokersInfo({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof importsGetSupportedBrokersInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type ImportsGetSupportedBrokersInfoQueryResult = NonNullable<Awaited<ReturnType<typeof importsGetSupportedBrokersInfo>>>
export type ImportsGetSupportedBrokersInfoQueryError = AxiosError<void>

/**
 * @summary Get Supported Brokers Info
 */
export const useImportsGetSupportedBrokersInfo = <TData = Awaited<ReturnType<typeof importsGetSupportedBrokersInfo>>, TError = AxiosError<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsGetSupportedBrokersInfo>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getImportsGetSupportedBrokersInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get User Import Sources
 */
export const importsGetUserImportSources = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UserImportSourceOutput[]>> => {
    
    return axios.default.get(
      `/imports/sources`,options
    );
  }


export const getImportsGetUserImportSourcesQueryKey = () => {
    return [`/imports/sources`] as const;
    }

    
export const getImportsGetUserImportSourcesQueryOptions = <TData = Awaited<ReturnType<typeof importsGetUserImportSources>>, TError = AxiosError<void | HTTPValidationError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsGetUserImportSources>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getImportsGetUserImportSourcesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof importsGetUserImportSources>>> = ({ signal }) => importsGetUserImportSources({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof importsGetUserImportSources>>, TError, TData> & { queryKey: QueryKey }
}

export type ImportsGetUserImportSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof importsGetUserImportSources>>>
export type ImportsGetUserImportSourcesQueryError = AxiosError<void | HTTPValidationError>

/**
 * @summary Get User Import Sources
 */
export const useImportsGetUserImportSources = <TData = Awaited<ReturnType<typeof importsGetUserImportSources>>, TError = AxiosError<void | HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof importsGetUserImportSources>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getImportsGetUserImportSourcesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Delete Import Source
 */
export const importsDeleteImportSource = (
    importSourceId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportsDeleteImportSource200>> => {
    
    return axios.default.delete(
      `/imports/delete_source/${importSourceId}`,options
    );
  }



export const getImportsDeleteImportSourceMutationOptions = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsDeleteImportSource>>, TError,{importSourceId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importsDeleteImportSource>>, TError,{importSourceId: string}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsDeleteImportSource>>, {importSourceId: string}> = (props) => {
          const {importSourceId} = props ?? {};

          return  importsDeleteImportSource(importSourceId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsDeleteImportSourceMutationResult = NonNullable<Awaited<ReturnType<typeof importsDeleteImportSource>>>
    
    export type ImportsDeleteImportSourceMutationError = AxiosError<void | HTTPValidationError>

    /**
 * @summary Delete Import Source
 */
export const useImportsDeleteImportSource = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsDeleteImportSource>>, TError,{importSourceId: string}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof importsDeleteImportSource>>,
        TError,
        {importSourceId: string},
        TContext
      > => {

      const mutationOptions = getImportsDeleteImportSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create Link Token
 */
export const importsCreateLinkToken = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateLinkTokenResponse>> => {
    
    return axios.default.post(
      `/imports/plaid/create_link_token`,undefined,options
    );
  }



export const getImportsCreateLinkTokenMutationOptions = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsCreateLinkToken>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importsCreateLinkToken>>, TError,void, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsCreateLinkToken>>, void> = () => {
          

          return  importsCreateLinkToken(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsCreateLinkTokenMutationResult = NonNullable<Awaited<ReturnType<typeof importsCreateLinkToken>>>
    
    export type ImportsCreateLinkTokenMutationError = AxiosError<void | HTTPValidationError>

    /**
 * @summary Create Link Token
 */
export const useImportsCreateLinkToken = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsCreateLinkToken>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof importsCreateLinkToken>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getImportsCreateLinkTokenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Create Access Token And Save Investments
 */
export const importsCreateAccessTokenAndSaveInvestments = (
    params: ImportsCreateAccessTokenAndSaveInvestmentsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportResponse>> => {
    
    return axios.default.post(
      `/imports/plaid/link_success`,undefined,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getImportsCreateAccessTokenAndSaveInvestmentsMutationOptions = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsCreateAccessTokenAndSaveInvestments>>, TError,{params: ImportsCreateAccessTokenAndSaveInvestmentsParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importsCreateAccessTokenAndSaveInvestments>>, TError,{params: ImportsCreateAccessTokenAndSaveInvestmentsParams}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsCreateAccessTokenAndSaveInvestments>>, {params: ImportsCreateAccessTokenAndSaveInvestmentsParams}> = (props) => {
          const {params} = props ?? {};

          return  importsCreateAccessTokenAndSaveInvestments(params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsCreateAccessTokenAndSaveInvestmentsMutationResult = NonNullable<Awaited<ReturnType<typeof importsCreateAccessTokenAndSaveInvestments>>>
    
    export type ImportsCreateAccessTokenAndSaveInvestmentsMutationError = AxiosError<void | HTTPValidationError>

    /**
 * @summary Create Access Token And Save Investments
 */
export const useImportsCreateAccessTokenAndSaveInvestments = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsCreateAccessTokenAndSaveInvestments>>, TError,{params: ImportsCreateAccessTokenAndSaveInvestmentsParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof importsCreateAccessTokenAndSaveInvestments>>,
        TError,
        {params: ImportsCreateAccessTokenAndSaveInvestmentsParams},
        TContext
      > => {

      const mutationOptions = getImportsCreateAccessTokenAndSaveInvestmentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Update Investments On Webhook Request
 */
export const importsUpdateInvestmentsOnWebhookRequest = (
    webhookRequest: WebhookRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    return axios.default.post(
      `/imports/plaid/webhook`,
      webhookRequest,options
    );
  }



export const getImportsUpdateInvestmentsOnWebhookRequestMutationOptions = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsUpdateInvestmentsOnWebhookRequest>>, TError,{data: WebhookRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importsUpdateInvestmentsOnWebhookRequest>>, TError,{data: WebhookRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsUpdateInvestmentsOnWebhookRequest>>, {data: WebhookRequest}> = (props) => {
          const {data} = props ?? {};

          return  importsUpdateInvestmentsOnWebhookRequest(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsUpdateInvestmentsOnWebhookRequestMutationResult = NonNullable<Awaited<ReturnType<typeof importsUpdateInvestmentsOnWebhookRequest>>>
    export type ImportsUpdateInvestmentsOnWebhookRequestMutationBody = WebhookRequest
    export type ImportsUpdateInvestmentsOnWebhookRequestMutationError = AxiosError<void | HTTPValidationError>

    /**
 * @summary Update Investments On Webhook Request
 */
export const useImportsUpdateInvestmentsOnWebhookRequest = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsUpdateInvestmentsOnWebhookRequest>>, TError,{data: WebhookRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof importsUpdateInvestmentsOnWebhookRequest>>,
        TError,
        {data: WebhookRequest},
        TContext
      > => {

      const mutationOptions = getImportsUpdateInvestmentsOnWebhookRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Csv Upload
 */
export const importsCsvUpload = (
    bodyImportsCsvUpload: BodyImportsCsvUpload, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImportResponse>> => {const formData = new FormData();
formData.append('file', bodyImportsCsvUpload.file)
formData.append('broker', bodyImportsCsvUpload.broker)
formData.append('account', bodyImportsCsvUpload.account)
if(bodyImportsCsvUpload.tz !== undefined && bodyImportsCsvUpload.tz !== null) {
 formData.append('tz', bodyImportsCsvUpload.tz)
 }
if(bodyImportsCsvUpload.start_date !== undefined) {
 formData.append('start_date', bodyImportsCsvUpload.start_date)
 }
if(bodyImportsCsvUpload.default_commission !== undefined) {
 formData.append('default_commission', bodyImportsCsvUpload.default_commission.toString())
 }

    
    return axios.default.post(
      `/imports/statement/upload`,
      formData,options
    );
  }



export const getImportsCsvUploadMutationOptions = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsCsvUpload>>, TError,{data: BodyImportsCsvUpload}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof importsCsvUpload>>, TError,{data: BodyImportsCsvUpload}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importsCsvUpload>>, {data: BodyImportsCsvUpload}> = (props) => {
          const {data} = props ?? {};

          return  importsCsvUpload(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportsCsvUploadMutationResult = NonNullable<Awaited<ReturnType<typeof importsCsvUpload>>>
    export type ImportsCsvUploadMutationBody = BodyImportsCsvUpload
    export type ImportsCsvUploadMutationError = AxiosError<void | HTTPValidationError>

    /**
 * @summary Csv Upload
 */
export const useImportsCsvUpload = <TError = AxiosError<void | HTTPValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importsCsvUpload>>, TError,{data: BodyImportsCsvUpload}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof importsCsvUpload>>,
        TError,
        {data: BodyImportsCsvUpload},
        TContext
      > => {

      const mutationOptions = getImportsCsvUploadMutationOptions(options);

      return useMutation(mutationOptions);
    }
    